export enum FilterOperationType {
  contains = "contains",
  notContains = "notContains",
  startWith = "startWith",
  endWith = "endWith",
  equal = "equal",
  notEqual = "notEqual",
}
